var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    height: "36px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(92, 97, 109)",
    d: "M32.648,35.999 L1.352,35.999 C0.606,36.000 0.001,35.411 -0.000,34.683 L-0.000,4.233 C0.001,3.505 0.606,2.916 1.352,2.917 L6.068,2.917 L6.068,1.317 C6.069,0.589 6.675,-0.000 7.420,0.001 L26.579,0.001 C27.325,-0.000 27.930,0.589 27.932,1.317 L27.932,2.917 L32.648,2.917 C33.393,2.916 33.999,3.505 34.000,4.233 L34.000,34.683 C33.999,35.411 33.393,36.000 32.648,35.999 ZM25.227,2.632 L8.773,2.632 L8.773,6.130 L25.227,6.130 L25.227,2.632 ZM31.295,5.549 L27.932,5.549 L27.932,7.446 C27.930,8.174 27.325,8.763 26.579,8.762 L7.420,8.762 C6.675,8.763 6.069,8.174 6.068,7.446 L6.068,5.549 L2.704,5.549 L2.704,33.368 L31.295,33.368 L31.295,5.549 ZM19.827,15.894 L19.827,15.894 L7.397,15.894 L7.397,13.268 L19.827,13.268 L19.827,15.894 ZM26.538,22.317 L7.397,22.317 L7.397,19.691 L26.538,19.691 L26.538,22.317 ZM26.538,28.741 L7.397,28.741 L7.397,26.114 L26.538,26.114 L26.538,28.741 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.35377982579d4452b7a1cfa67ad8c738.svg";
export { ForwardRef as ReactComponent };